// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__DZaNY","title":"Info_title__2mEGF","selects":"Info_selects__1vSO6","requiredAsterisk":"Info_requiredAsterisk__-fC-7"};